import divOne from "../../images/division-logos/division-one-logo.png";
import divTwo from "../../images/division-logos/division-two-logo.png";
import divThree from "../../images/division-logos/division-three-logo.png";
import divFour from "../../images/division-logos/division-four-logo.png";
import divFive from "../../images/division-logos/division-five-logo.png";
import divSix from "../../images/division-logos/division-six-logo.png";
import divSeven from "../../images/division-logos/division-seven-logo.png";
import divEight from "../../images/division-logos/division-eight-logo.png";

export const divisionLogos = {
  1: divOne,
  2: divTwo,
  3: divThree,
  4: divFour,
  5: divFive,
  6: divSix,
  7: divSeven,
  8: divEight,
};
